import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export const useFormatMessage = () => {
  const intl = useIntl();
  return useCallback((id: string, params?: any) => intl.formatMessage({ id }, params), [intl]);
};
